import { Routes, Route } from "react-router-dom";
import UserLogin from "./components/Auth/UserLogin";
import Homepage from "./components/Dashboard/Homepage";
import LogoutPage from "./components/Auth/Logoutpage";
import ForgotPassword from "./components/Auth/Forgotpassword";
import ProtectedRoute from "./components/protectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/App.css";

function App() {
  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<UserLogin />} />
        <Route
          path="/homepage"
          element={
            <ProtectedRoute>
              <Homepage />
            </ProtectedRoute>
          }
        />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
      </Routes>
    </>
  );
}

export default App;
